module.exports = __webpack_public_path__ + "img/bul_member_regular.68ec2088.svg";